import { DataGrid, mergeSx, type DataGridProps } from '@shared/components';

export default function BaseQSetList(props: Readonly<DataGridProps>) {
  const { sx: sxProp, ...restProps } = props;

  return (
    <DataGrid
      columnHeaderHeight={48}
      rowHeight={52}
      disableColumnMenu
      sx={mergeSx(
        (theme) => ({
          // This unstable datagrid radius and borderRadius is needed to be set to 0 in order to display the border radius of the table
          '--unstable_DataGrid-radius': theme.shape.rounded(0),
          borderRadius: theme.shape.rounded(0),
          bgcolor: theme.palette.background.paper,
          '.MuiDataGrid-columnHeaders': {
            bgcolor: theme.palette.grey[100],
            borderTop: '1px solid',
            borderBottom: '1px solid',
            borderColor: theme.palette.grey[200],
          },
          '& .MuiCheckbox-root': {
            color: theme.palette.grey[400],
            p: theme.spacing(3),
            '&.Mui-checked': {
              color: theme.palette.primary.main,
            },
          },
          '& .MuiDataGrid-row .MuiDataGrid-cell': {
            alignItems: 'start',
            display: 'flex',
            p: theme.spacing(3),
            '&.MuiDataGrid-cellCheckbox': {
              p: theme.spacing(0),
            },
          },
          '& .MuiDataGrid-cell, & .MuiDataGrid-row': {
            borderBottom: '1px solid',
            borderColor: theme.palette.grey[200],
          },
          '& .MuiDataGrid-row': {
            '&.Mui-selected': {
              bgcolor: theme.palette.primary.lighter,
            },
          },
          '& .MuiDataGrid-cell:last-of-type': {
            p: theme.spacing(1.5),
          },
          '> .MuiDivider-root': {
            borderColor: theme.palette.grey[200],
            mt: '-1px',
          },
          // Style override for Footer
          '> .MuiBox-root': {
            p: theme.spacing(3, 4),
            '& .MuiToolbar-root': {
              minHeight: 'unset',
              height: 'unset',
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                m: 0,
              },
              '& .MuiTablePagination-actions': {
                ml: theme.spacing(1),
                '> button': {
                  p: theme.spacing(1),
                },
              },
            },
          },
        }),
        sxProp,
      )}
      {...restProps}
    />
  );
}
